import React, {useEffect, useState} from 'react';
import {Box, Button, Table, TableBody, TableHead, TextField, Typography} from "@mui/material";
import {StyledTableCell, StyledTableRow} from '../common/table/TableStyles';
import TableLoadingMockup from "../common/table/TableLoadingMockup";
import {useNavigate} from "react-router-dom";
import DoneIcon from '@mui/icons-material/Done';
import {useLazyGetMonthReconciliationsQuery} from "../../store/rtk-api/reconciliations/reconciliations";
import IsError from "../common/IsError";
import {useAppDispatch, useTypedSelector} from "../../store";
import {setMonthDataCount} from "../../store/calendar/calendar.slice";
import {
    useUpdateDailyReconciliationsVisitMutation
} from "../../store/rtk-api/daily_reconciliations/daily_reconciliations";

const mapping = {
    'id': '',
    'doctorName': 'Врач',
    // 'procedure': 'Процедура',
    'patient': 'Пациент',
    'visitDate': 'Дата визита',
    // 'reconciliationDoq': 'Сверка Doq.kz',
    'reconciliationClinic': 'Сверка клиники',
    'comments': 'Коментарий',

}

const MonthDataList: React.FC = () => {
    const [getMonthReconciliations, {data: monthReconciliations2, isError, isLoading}] = useLazyGetMonthReconciliationsQuery()
    const dispatch = useAppDispatch()
    const {query, visit_date, page, date} = useTypedSelector(state => state.monthData)
    const {addressId} = useTypedSelector(state=>state.header)

    const monthReconciliations = {
        count: 2,
        next: null,
        previous: null,
        results: [
            {
                id: 1,
                patient: {
                    id: 1,
                    first_name: "John",
                    phone: "123-456-7890"
                },
                appointment_time: "2023-01-15T09:30:00Z",
                appointment_doctor_time: {
                    id: 1,
                    doctor: {
                        id: 1,
                        first_name: "Alice",
                        last_name: "Smith",
                        middle_name: "B.",
                        photo: "https://example.com/photos/alice_smith.jpg",
                        experience_years: 10
                    },
                    date: "2023-01-15"
                },
                note: "Routine check-up",
                is_visited: true
            },
          ]}


                        useEffect(() => {
        getMonthReconciliations({query,visit_date, page, addressId, date})
    }, [query, visit_date, page, addressId, date])

    useEffect(() => {
        if (monthReconciliations) {
            dispatch(setMonthDataCount(monthReconciliations?.count))
        }
    }, [monthReconciliations?.count])

    const [isInputShow, setInputShow] = useState(false)
    const [inputShowId, setInputShowId] = useState<number | null>(null)
    const [value, setValue] = useState('')
    const [createNote, {}] = useUpdateDailyReconciliationsVisitMutation()
    const handleAddComment = (id: number) => {
        createNote({id, body:{
            note:value
            }})
        setInputShow(false)
    }
    const handleShowInput = (id: number) => {
        setInputShowId(id)
        setInputShow(prevState => !prevState)
        setValue('')
    }
    const handleSetValue = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value)
    }

    return (
        <>
            <IsError isError={isError}/>
            <Table>
                <TableHead>
                    <StyledTableRow>
                        {Object.values(mapping).map((title, idx) => {
                            return (
                                <StyledTableCell key={idx} align={"left"}>{title}</StyledTableCell>
                            )
                        })}
                    </StyledTableRow>
                </TableHead>
                <TableBody>
                    {isLoading ?
                        <TableLoadingMockup cellCount={6} rowCount={20}/>
                        :
                        monthReconciliations?.results.map((item, ind) => (
                            <StyledTableRow key={item.id}>
                                <StyledTableCell>{ind + 1}</StyledTableCell>
                                <StyledTableCell>
                                    {`${item?.appointment_doctor_time?.doctor?.last_name} ${item?.appointment_doctor_time?.doctor?.first_name} ${item?.appointment_doctor_time?.doctor?.middle_name}`}
                                </StyledTableCell>
                                {/*<StyledTableCell>{item.procedure}</StyledTableCell>*/}
                                <StyledTableCell>{`${item?.patient.first_name} ${item?.patient.phone}`}</StyledTableCell>
                                <StyledTableCell>{item?.appointment_doctor_time?.date}</StyledTableCell>
                                {/*<StyledTableCell>{item.reconciliationDoq} Был<Checkbox/></StyledTableCell>*/}
                                {/*<StyledTableCell>{item.reconciliationClinic} Был<Checkbox/></StyledTableCell>*/}
                                <StyledTableCell>{item?.is_visited?'Посетил':'Не посетил'}</StyledTableCell>
                                <StyledTableCell>
                                    {item?.note?item.note:<Typography sx={{color: "secondary.main", fontSize:"14px", cursor:"pointer"}}
                                             onClick={() => handleShowInput(item.id)}
                                    >{isInputShow && inputShowId === item.id ? 'Отмена' : 'Добавить примечание'}
                                    </Typography>}
                                    {isInputShow && inputShowId === item.id && <>
                                        <Box sx={{display: "flex", alignItems: "center"}} component={"span"}>
                                            <TextField size={"small"} sx={{minWidth: "80%"}} value={value}
                                                       onChange={handleSetValue} multiline maxRows={2} minRows={1}/>
                                            <Button variant={"contained"}
                                                    sx={{
                                                        height: "40px",
                                                        borderRadius: 0,
                                                        border: "none",
                                                        backgroundColor: "secondary.main"
                                                    }}
                                                    onClick={() => handleAddComment(item.id)}>
                                                <DoneIcon/>
                                            </Button>
                                        </Box>
                                    </>

                                    }
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                </TableBody>
            </Table>
        </>
    );
};

export default MonthDataList;
